import { lazy } from 'react';

export default [
    {
        path: '/hengchun-guide',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'HengchunGuideLayout' */ './layout')),
    },
];
